import { GlobalAlertBar } from "@vrf/fr-vrf-core-react";
import { JSX, CSSProperties } from "react";
import { createPortal } from "react-dom";
import { EnvTypeCd } from "../../util/general-code/enums/general-codes";

require("./createModal.css");

const modalStyle: CSSProperties = {
  position: "fixed",
  zIndex: 50,
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  overflow: "auto",
  backgroundColor: "rgba(0,0,0,0.6)",
  display: "flex",
  alignItems: "center",
};

const defaultModalContentStyle: CSSProperties = {
  position: "sticky",
  backgroundColor: "#F4F4F4",
  margin: "auto",
};

const modalSmallStyle: CSSProperties = {
  width: "40%",
  height: "40%",
};
const modalMediumStyle: CSSProperties = {
  width: "60%",
  height: "60%",
};
const modalLargeStyle: CSSProperties = {
  width: "80%",
  height: "80%",
};

const topModalContentStyle: CSSProperties = {
  marginTop: "200px",
  marginLeft: "40%",
  display: "inline-block",
};

export const createModal = (
  title: string,
  content: JSX.Element,
  closeEvent: Function,
  pageSize?: "small" | "medium" | "large",
  showEvent?: Function,
  env?: string,
): JSX.Element => {
  let showFlag = true;
  const clickEvent = () => {
    if (!showFlag) {
      if (showEvent instanceof Function) {
        showEvent();
      }
    }
  };

  const mouseEnterEvent = () => {
    showFlag = true;
  };

  const mouseLeaveEvent = () => {
    showFlag = false;
  };

  const modal = (
    <div style={modalStyle} onClick={clickEvent}>
      <div
        style={{
          ...(showEvent ? topModalContentStyle : defaultModalContentStyle),
          ...(pageSize === "small"
            ? modalSmallStyle
            : pageSize === "medium"
              ? modalMediumStyle
              : modalLargeStyle),
        }}
        onMouseEnter={mouseEnterEvent}
        onMouseLeave={mouseLeaveEvent}
      >
        <div
          className={`popup-title ${
            env === EnvTypeCd.PRD
              ? "prd-header"
              : env === EnvTypeCd.STG
                ? "stg-header"
                : ""
          }`}
        >
          <span>{title}</span>
        </div>
        <div className="popup-content">
          <GlobalAlertBar modal={true} />
          <div>{content}</div>
        </div>
      </div>
    </div>
  );
  const modalElement = document.getElementById("modal_root");
  return createPortal(modal, modalElement!!);
};
